export const notificationType = {
	'new-order': 'Nueva orden de producto N°',
	'new-claim': 'Reclamo N°',
	'new-quotation': 'Cotizacion N°',
	'new-preorder': 'Nueva pre-orden N°',
	'new-recipe': 'Nueva receta orden N°'
};
